import React from 'react';
import heroImg from './../../assets/img/banner.png';
import './style.scss';
const Header = () => {
  return (
    <div className="header">
      <div className="top-img"></div>
      <div className="banner">
        <div className="banner-logo"></div>
        <div className="banner-title">CloudVik - Mini Computer Cluster</div>
      </div>
      <div className="header-hero">
        <img src={heroImg} />
      </div>
    </div>
  );
};

export default Header;
